import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSignOutMutation } from 'api/main';
import { userSelectors } from 'reducers';
import { logoutClosed } from 'reducers/user';
import { RoleNames } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import { ConfirmDialog } from 'components';
import { Typography } from '@mui/material';
import { useMatchAtLeastOneRole } from 'utils/hooks/subscriptions';

const ConfirmLogoutDialog = () => {
    const dispatch = useDispatch();

    const logoutOpen = useSelector(userSelectors.getLogoutDialogState);
    const currentSubscription = useSelector(userSelectors.getCurrentSubscription);

    const [signOut, { isLoading: signOutLoading }] = useSignOutMutation();

    const isDistributor = useMatchAtLeastOneRole([
        RoleNames.COMMERCIALISATEUR,
        RoleNames.ADMIN_CIF,
        RoleNames.PSI,
    ]);

    const handleConfirm = () => {
        signOut(true);
    };

    const handleClose = () => {
        dispatch(logoutClosed());
    };

    return (
        <ConfirmDialog
            open={logoutOpen}
            handleConfirm={handleConfirm}
            handleClose={handleClose}
            loading={signOutLoading}
            title={texts.DEJA_QUITTER}
            confirmText={texts.CONFIRMER}
            cancelText={texts.CANCEL}
        >
            <React.Fragment>
                <Typography sx={{ marginBottom: '20px' }}>
                    {isDistributor ? texts.CONTINUER_INSCRIPTION : texts.CONTINUER_SOUSCRIPTION}
                </Typography>
                <Typography>{texts.A_TRES_BIENTOT}</Typography>
                <Typography>
                    {texts.L_EQUIPE_SGP_NAME(currentSubscription?.investmentFund?.sgp?.name)}
                </Typography>
            </React.Fragment>
        </ConfirmDialog>
    );
};

export default ConfirmLogoutDialog;
